<div class="c">
  <div class="headerback">
    <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
       <mat-icon>arrow_back</mat-icon>
     </button> -->

    <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backhome()"
      class="backbtn">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <p class="title">{{publicservice.Texts.Texts["history1"]}}</p>

  </div>

  <mat-spinner id="loading" *ngIf="loading"></mat-spinner>

  <div class="items">
    <div class="expDiv" *ngFor="let item of historyArray">
      <mat-accordion>
        <!-- <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              This is the expansion title
            </mat-panel-title>
            <mat-panel-description>
              This is a summary of the content
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>This is the primary content of the panel.</p>
        </mat-expansion-panel> -->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <div class="line" *ngIf="(item.status == 0 && item.status_zero == 0)"></div>
            <div class="line2" *ngIf="(item.status == 1 )"></div>
            <div class="line3" *ngIf="(item.status == 0  && item.status_zero == 1)"></div>
            <mat-panel-title style="font-family: iransansbold;">
              <div>
                <p> درخواست در تاریخ {{item.date_persian}}</p>
                <br>
                <p style="width: 100%;float: right;text-align: right;color: #92dd7a;"
                  *ngIf="(item.status == 0 && item.status_zero == 0)">انجام شده</p>
                <p style="width: 100%;float: right;text-align: right;color: rgb(223, 200, 0);"
                  *ngIf="(item.status == 0 && item.status_zero == 1)">در انتظار رسیدن راننده</p>
                <p style="width: 100%;float: right;text-align: right;color: rgb(250, 123, 123);"
                  *ngIf="(item.status == 1)">در حال جستجو برای راننده</p>
              </div>
            </mat-panel-title>
            <mat-panel-description>
              <!-- Currently I am {{panelOpenState ? 'open' : 'closed'}} -->

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="text" style="font-family: iransans">
            <div class="line" *ngIf="(item.status == 0 && item.status_zero == 0)"></div>
            <div class="line2" *ngIf="(item.status == 1 )"></div>
            <div class="line3" *ngIf="(item.status == 0  && item.status_zero == 1)"></div>
            <p style="font-weight: bold;width: 100%;float: right;text-align: right;margin-bottom: 15px;
            color: gray;" *ngIf="(item.status == 0 && item.status_zero == 0 )">
              دریافتی از این درخواست: {{item.money}} تومان
            </p>


            <div *ngIf="(item.status == 0 && item.status_zero == 1)" style="background-color: rgb(245, 240, 196);margin-bottom: 20px;
            width: 100%;height: fit-content;border-radius: 10px;padding: 20px;">
              <p style="font-weight: bold;width: 100%;float: right;text-align: right;margin-bottom: 20px;
            color: black;font-size: 17px;">مشخصات تحویل گیرنده:</p>
              <p style="width: 100%;float: right;text-align: right;margin-bottom: 15px;
            color: black;"> <span style="font-weight: bold;">نام و نام خانوادگی:</span> {{item.driver.name}}</p>
              <p style="width: 100%;float: right;text-align: right;margin-bottom: 15px;
              color: black;"> <span style="font-weight: bold;">شماره تلفن:</span> <a href="tel:{{item.driver.phone}}"
                  style="color: rgb(155, 145, 61);padding-right: 5px;">{{item.driver.phone}}</a></p>
              <p style="width: 100%;float: right;text-align: right;margin-bottom: 15px;
            color: black;"> <span style="font-weight: bold;">مدل ماشین:</span> {{item.driver.car_model}}</p>
              <div class="field" style="word-wrap: break-word;">
                <p style="padding-left: 10px;color: black; font-family: iransans;font-weight: bold; " class="pelakTitr">
                  پلاک ماشین:</p>
                <div
                  style="font-size: large;word-wrap: break-word;border: 2px solid black;border-radius: 3px;margin-top: -10px;display: flex;"
                  class="borderBlack">

                  <p class="pelak">
                    {{item.driver.car_number}}</p>
                  <div class="blue">
                    <img class="icon icon-user" src="assets/images/iran.png" style="width: 15px;border-radius: 0;">
                  </div>
                </div>
              </div>
            </div>

            <div style="color: gray;">
              <p  style="width: 100%; text-align: right;">
                نوع درخواست: انتقال پسماند</p>

                  <div class="form-group-btn" style="justify-content: center;width: fit-content;margin: auto;" *ngIf="(item.status == 1 )">
                <button mat-button type="submit" class="btn btn-block create-account2" (click)="cancel(item.id)">
                    لغو درخواست
                </button>
            </div>

            <p *ngIf="(item.shopping_cart.shoe != 0 && item.shopping_cart.shoe != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.shoe}} کیلو قوطی</p>
              <p *ngIf="(item.shopping_cart.rice != 0 && item.shopping_cart.rice != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.rice}} کیلو برنج</p>
              <p *ngIf="(item.shopping_cart.plastic != 0 && item.shopping_cart.plastic != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.plastic}} کیلو پلاستیکی</p>
              <p *ngIf="(item.shopping_cart.bread != 0 && item.shopping_cart.bread != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.bread}} کیلو نان خشک</p>
              <p *ngIf="(item.shopping_cart.cpu != 0 && item.shopping_cart.cpu != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.cpu}} کیلو الکترونیکی</p>
              <p *ngIf="(item.shopping_cart.paper != 0 && item.shopping_cart.paper != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.paper}} کیلو کارتن و کاغذ</p>
              <p *ngIf="(item.shopping_cart.canned_food != 0 && item.shopping_cart.canned_food != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.canned_food}} کیلو حلبی</p>
              <p *ngIf="(item.shopping_cart.bottle != 0 && item.shopping_cart.bottle != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.bottle}} کیلو شیشه ای</p>
              <p *ngIf="(item.shopping_cart.dry_waste != 0 && item.shopping_cart.dry_waste != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.dry_waste}} کیلو مخلوط خشک</p>
              <p *ngIf="(item.shopping_cart.iron != 0 && item.shopping_cart.iron != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.iron}} کیلو آهن</p>
              <p *ngIf="(item.shopping_cart.mes != 0 && item.shopping_cart.mes != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.mes}} کیلو مس</p>
              <p *ngIf="(item.shopping_cart.chodan != 0 && item.shopping_cart.chodan != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.chodan}} کیلو چدن</p>
              <p *ngIf="(item.shopping_cart.pet != 0 && item.shopping_cart.pet != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.pet}} کیلو pet</p>
              <p *ngIf="(item.shopping_cart.basket != 0 && item.shopping_cart.basket != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.basket}} کیلو سبد</p>
              <p *ngIf="(item.shopping_cart.lak != 0 && item.shopping_cart.lak != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.lak}} کیلو لاک</p>
                <p *ngIf="(item.shopping_cart.al_sabok != 0 && item.shopping_cart.al_sabok != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.al_sabok}} کیلو آلومینیوم سبک</p>
                <p *ngIf="(item.shopping_cart.al_sangin != 0 && item.shopping_cart.al_sangin != null)"
                style="width: 100%; text-align: right;">
                {{item.shopping_cart.al_sangin}} کیلو آلومینیوم سنگین</p>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
